import Host from '@app/store/Host';
import LocaleCode from '@app/store/LocaleCode';
import { HostWithSigningProperties } from '@app/store/transport-layer/types/participant';

export function convertTransportHostsToAppHosts(
  transportHosts: HostWithSigningProperties[]
): Host[] {
  return transportHosts.map(({ dataLabel, name, contact, locale, id }) => ({
    dataLabel,
    name,
    contactInfo: contact,
    locale: (locale || LocaleCode.ENGLISH) as LocaleCode,
    participantId: id,
  }));
}
